import numeral from "numeral";
// Components
export function formatPublishedDate(date) {
  let today = new Date().getTime();
  let pubDate = new Date(date).getTime();
  let diff = (today - pubDate) / 1000;

  let arr = [
    { div: 60, comp: 60 },
    { div: 60, comp: 24 },
    { div: 24, comp: 7 },
    { div: 7, comp: 30 / 7 },
    { div: 30 / 7, comp: 12 },
    { div: 12, comp: 60 }
  ];

  let str = ["minute", "hour", "day", "week", "month", "year"];

  for (let i = 0; i < arr.length; i++) {
    diff = diff / arr[i].div;
    if (diff < arr[i].comp)
      return `${Math.floor(diff)} ${str[i]}${
        Math.floor(diff) === 1 ? "" : "s "
      } ago`;
  }

  return "----";
}

export function formatViews(views) {
  if (views === 0) return "No";
  else if (views < 1000) return views;
  let formatedView = numeral(views)
    .format("0.0a")
    .replace(/\.0([a-z])$/, "$1")
    .replace(/([0-9][0-9])\.[0-9]([a-z])/, "$1$2")
    .replace(/.0$/, "");
  return formatedView;
}

// Reducers
export function gotMoreData(payload, state) {
  let pS = { ...state };
  pS.results.prevPageToken = payload.prevPageToken;
  pS.results.nextPageToken = payload.nextPageToken;
  pS.results.items = [...pS.results.items, ...payload.items];
  ++pS.pageNum;
  return pS;
}

export function updateState(payload, state) {
  let pS = { ...state };
  const index =
    payload.index + (pS.pageNum - 1) * pS.results.pageInfo.resultsPerPage;

  pS.results.items[index].statistics = { ...payload.data.statistics };
  pS.results.items[index].contentDetails = { ...payload.data.contentDetails };
  pS.results.items[index].snippet.detailDescription = payload.data.description;
  return pS;
}

// Action, Components
export function formatDuration(duration) {
  let formatedDuration = duration.replace(/^PT|S$/g, "");
  formatedDuration = formatedDuration.replace(/M$/g, "M0");
  if (formatedDuration.indexOf("M") === -1) {
    formatedDuration = formatedDuration.replace(/H/, "H0:");
  }
  if (
    formatedDuration.indexOf("H") !== -1 ||
    formatedDuration.indexOf("M") !== -1
  )
    formatedDuration = formatedDuration.replace(/H|M/g, ":");
  else formatedDuration = "0:" + formatedDuration;

  // formated duration array;
  let FDA = formatedDuration.split(":");
  for (let i = 0; i < FDA.length; i++) {
    if (FDA.length === 3 && i === 0) continue;
    if (FDA[i] < 10) FDA[i] = "0" + FDA[i];
  }
  formatedDuration = FDA.join(":");
  return formatedDuration;
}
